export default "__VITE_ASSET__DzYsnjr1LtW1tBWqsYm2RQ__ 480w, __VITE_ASSET__Ngmgj7KrmSrUoXH_NFNtFA__ 745w";